import React from 'react';
import { Box, Container, Paper, Typography, Button } from '@mui/material';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import { withTheme } from "@mui/styles";

const MenuLogin = ({ children, location, theme }) => {
    const isRegistration = location.pathname === '/registration';

    return (
        <Box
            sx={{
                minHeight: 'calc(100vh - 180px)',
                py: 6,
                px: 2,
                background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)',
            }}
        >
            <Container maxWidth="lg">
                <Paper
                    elevation={3}
                    sx={{
                        borderRadius: 3,
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        minHeight: isRegistration ? '800px' : '500px',
                    }}
                >
                    {/* Side Banner */}
                    <Box
                        sx={{
                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark || '#5a3d8a'} 100%)`,
                            color: 'white',
                            p: { xs: 4, md: 5 },
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: { xs: '100%', md: '320px' },
                            flexShrink: 0,
                            textAlign: 'center',
                        }}
                    >
                        <img
                            src="/vividKidsLogo.svg"
                            alt="NeuroLeap"
                            style={{
                                width: '160px',
                                marginBottom: '32px',
                                filter: 'brightness(0) invert(1)',
                            }}
                        />
                        <Typography variant="h4" sx={{ fontWeight: 600, mb: 2 }}>
                            {isRegistration ? 'Join NeuroLeap' : 'Welcome Back'}
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 4, opacity: 0.9, lineHeight: 1.6 }}>
                            {isRegistration
                                ? 'Create an account to access all features and connect with our community.'
                                : 'Sign in to continue to your account and explore our platform.'
                            }
                        </Typography>

                        <Box sx={{ mt: 2 }}>
                            <Typography variant="body2" sx={{ mb: 2, opacity: 0.8 }}>
                                {isRegistration ? 'Already have an account?' : "Don't have an account?"}
                            </Typography>
                            <Button
                                component={RouterLink}
                                to={isRegistration ? '/login' : '/registration'}
                                variant="outlined"
                                size="large"
                                sx={{
                                    color: 'white',
                                    borderColor: 'rgba(255,255,255,0.6)',
                                    '&:hover': {
                                        borderColor: 'white',
                                        backgroundColor: 'rgba(255,255,255,0.1)',
                                    },
                                    borderRadius: 2,
                                    px: 4,
                                    py: 1,
                                }}
                            >
                                {isRegistration ? 'Sign In' : 'Register'}
                            </Button>
                        </Box>
                    </Box>

                    {/* Form Content */}
                    <Box
                        sx={{
                            flex: 1,
                            p: { xs: 3, sm: 4, md: 6 },
                            backgroundColor: 'white',
                            overflowY: 'auto',
                        }}
                    >
                        {children}
                    </Box>
                </Paper>

                {/* Help Link */}
                <Box sx={{ textAlign: 'center', mt: 4 }}>
                    <Typography variant="body1" color="text.secondary">
                        Need help? Contact{' '}
                        <a
                            href="mailto:support@neuroleap.com"
                            style={{
                                color: theme.palette.primary.main,
                                textDecoration: 'none',
                            }}
                        >
                            support@neuroleap.com
                        </a>
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
}

export default withTheme(withRouter(MenuLogin));
